import DynamicArticleCard from "./DynamicArticleCard"

export default DynamicArticleCard